import { useEffect, useMemo, useState } from 'react';

import { Empty, Input, Skeleton } from 'antd';
import { T } from 'react-translator-component';

import * as S from './styled';

import { getUserPrivateStation } from '../../../hooks/users';
import { UserPrivateStationProps } from '../../../types/responses/UsersPrivateStation';
import { usersListFilter } from '../../../utils/list';
import { Search } from '../../molecules/Search';

interface VoucherSelectUsersListProps {
  userSelectedPks?: number[];
}
const VoucherSelectedUsersList = ({
  userSelectedPks,
}: VoucherSelectUsersListProps) => {
  const [usersDataList, setUsersDataList] = useState<UserPrivateStationProps[]>(
    [],
  );
  const [loading, setLoading] = useState<boolean>(false);
  const [searchValue, setSearchValue] = useState<string>('');

  const filteredSearch = useMemo(() => {
    const filteredUsers = usersDataList.filter((user) =>
      userSelectedPks?.includes(user.user_pk),
    );

    const filteredList = usersListFilter(searchValue, filteredUsers).map(
      (user) => user.user_pk,
    );

    return filteredList;
  }, [searchValue, userSelectedPks, usersDataList]);

  useEffect(() => {
    (async function () {
      try {
        setLoading(true);

        const { userPrivateStationList } = await getUserPrivateStation('');

        setUsersDataList(userPrivateStationList);

        setLoading(false);
      } catch {
        setLoading(false);
      }
    })();
  }, []);

  if (loading) {
    return <Skeleton active />;
  }

  return (
    <S.Div>
      <S.Header>
        <S.SelectedUsersCount>
          {filteredSearch.length}{' '}
          {filteredSearch.length > 1 ? T('Users') : T('User')}
        </S.SelectedUsersCount>

        <Search
          className='search_input'
          value={searchValue}
          action={(value) => setSearchValue(value)}
          placeholder={T('Search')}
          closeBtn={() => setSearchValue('')}
        />
      </S.Header>

      <S.ScrollDiv>
        {filteredSearch.length ? (
          filteredSearch.map((selectedUser, index) => (
            <Input
              key={index}
              style={{ height: '40px', marginBottom: 8 }}
              disabled
              value={
                usersDataList.find((user) => user.user_pk === selectedUser)
                  ?.email
              }
            />
          ))
        ) : (
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={T('No users selected')}
          />
        )}
      </S.ScrollDiv>
    </S.Div>
  );
};

export default VoucherSelectedUsersList;
